module.exports = __webpack_public_path__ + "static/media/FONDO.685fab07.png";